export default function (rows) {
  let levelsSeen = []
  if (rows.length > 0) {
    for (let i = rows.length - 1; i >= 0; i--) {
      var level
      var row = rows[i]
      row.hideLevels = []
      levelsSeen = levelsSeen.filter(l => row.level > l)
      if (row.level > 1) {
        for (level = 1; level < row.level; level++) {
          if (!Array.from(levelsSeen).includes(level)) {
            row.hideLevels.push(level)
          }
        }
      }
      if (!Array.from(levelsSeen).includes(row.level)) {
        levelsSeen.push(row.level)
      }
    }
  }
  return rows
}
